import Enums from '../constants/Enums';
import Logger from './Logger';

const { paymentDetailsEnum } = Enums;

const CacheManager = () => {
  try {
    window.localStorage.removeItem(
      Enums.localStorageKeys.CREDIT_CARD_DETAILS_CACHE,
    );
    const ccDetails = {};
    ccDetails[paymentDetailsEnum.IS_LOOKING] = false;
    ccDetails[paymentDetailsEnum.IS_WAITING] = false;
    ccDetails[paymentDetailsEnum.IS_HELD] = false;
    ccDetails[paymentDetailsEnum.IS_DROPPED] = false;
    ccDetails[paymentDetailsEnum.IS_DISPLAYED] = false;
    ccDetails[paymentDetailsEnum.HS_COUNT] = 0;
    ccDetails[paymentDetailsEnum.HW_COUNT] = 0;
    ccDetails[paymentDetailsEnum.CURRENT_TYPE] = null;
    ccDetails[paymentDetailsEnum.DETAILS_LIST] = null;
    ccDetails[paymentDetailsEnum.CONTACT_ID] = null;
    ccDetails[paymentDetailsEnum.ORIGINAL_CONTACT_ID] = null;
    window.localStorage.setItem(
      Enums.localStorageKeys.CREDIT_CARD_DETAILS_CACHE,
      JSON.stringify(ccDetails),
    );
    return true;
  } catch (err) {
    Logger.error(err);
    return false;
  }
};
export default CacheManager;
